import type { FC } from "react";
import type { SportsEventSearchResult } from "src/http/api-types";
import { MatchupCard } from "../MatchupCard";
import { StyledEventsNearYouList } from "./styled-components";

interface Props {
  events: SportsEventSearchResult[];
  onClick?: (id: number | undefined) => void;
}

/**
 * Events Near You Carousel/List on Sports Subcategory Pages
 */
export const EventsNearYouList: FC<Props> = ({ events, onClick }) => (
  <StyledEventsNearYouList>
    {events.map((evt) => (
      <MatchupCard key={evt.eventId} onClick={onClick} {...evt} />
    ))}
  </StyledEventsNearYouList>
);
